// Version history drawer for the Agent Skills Editor.
// Editor spec §3.7 / UI_GUIDE §3.7.
//
// This file now delegates to GenericHistoryDrawer + agentFileVersionAdapter.
// The Phase 1 API (fileId, currentVersion, isDirty, currentFrontmatter, currentBody)
// is preserved unchanged so existing callers don't need to be updated.

import type { Frontmatter } from "@/types/agent-skills";
import { GenericHistoryDrawer } from "@/components/history/GenericHistoryDrawer";
import {
  agentFileVersionAdapter,
  type AgentFileCurrentState,
} from "@/components/history/agentFileVersionAdapter";

interface HistoryDrawerProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  /** The ID of the file whose history is shown. */
  fileId: string;
  /** The file's current version number (for optimistic locking on restore). */
  currentVersion: number;
  /** Whether the editor currently has unsaved changes. */
  isDirty: boolean;
  /** The current (possibly unsaved) frontmatter — used to show diff against selected version. */
  currentFrontmatter: Frontmatter;
  /** The current (possibly unsaved) body. */
  currentBody: string;
}

export function HistoryDrawer({
  open,
  onOpenChange,
  fileId,
  currentVersion,
  isDirty,
  currentFrontmatter,
  currentBody,
}: HistoryDrawerProps) {
  const currentState: AgentFileCurrentState = {
    frontmatter: currentFrontmatter,
    body: currentBody,
  };

  return (
    <GenericHistoryDrawer
      open={open}
      onOpenChange={onOpenChange}
      entityId={fileId}
      currentVersion={currentVersion}
      isDirty={isDirty}
      currentState={currentState}
      adapter={agentFileVersionAdapter}
      title="Version history"
    />
  );
}
